import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  DateTimeService,
  MOMENT_LONG_ABBREVIATED_DATE_FORMAT,
} from 'i2g-ng-utils';

export interface IRelativeDateTranslationKey {
  today: string;
  yesterday: string;
  inOneDay: string;
  nDaysAgo: string;
  inNDays: string;
}

const defaultDateTranslationKey: IRelativeDateTranslationKey = {
  today: 'DATE.TODAY',
  yesterday: 'DATE.YESTERDAY',
  inOneDay: 'DATE.IN_ONE_DAY',
  nDaysAgo: 'DATE.N_DAYS_AGO',
  inNDays: 'DATE.IN_N_DAYS',
};

@Pipe({
  name: 'friendlyDate',
})
export class FriendlyDatePipe implements PipeTransform {
  constructor(
    private _dateTimeService: DateTimeService,
    private _translateService: TranslateService
  ) {}

  // TODO: refactor this to be cleaner
  transform(
    date: string,
    onlyAbsoluteDate: boolean = true,
    minRelativeDays: number = 0,
    maxRelativeDays: number = 0,
    format: string = MOMENT_LONG_ABBREVIATED_DATE_FORMAT,
    dateTranslationKey: IRelativeDateTranslationKey = defaultDateTranslationKey
  ): string {
    if (!onlyAbsoluteDate) {
      const daysDifference = this._dateTimeService.calculateNumberOfUnitsFromDate(
        date,
        this._dateTimeService.getDateString(),
        'day',
        'days',
        false
      );

      const {
        today,
        yesterday,
        inNDays,
        inOneDay,
        nDaysAgo,
      } = dateTranslationKey;

      if (daysDifference === 0) {
        return this._translateService.instant(today);
      } else if (daysDifference === -1) {
        return this._translateService.instant(yesterday);
      } else if (daysDifference === 1) {
        return this._translateService.instant(inOneDay);
      } else if (
        (minRelativeDays === null || daysDifference >= minRelativeDays * -1) &&
        daysDifference <= -2
      ) {
        return this._translateService.instant(nDaysAgo, {
          number: daysDifference * -1,
        });
      } else if (
        daysDifference >= 2 &&
        (maxRelativeDays === null || daysDifference <= maxRelativeDays)
      ) {
        return this._translateService.instant(inNDays, {
          number: daysDifference,
        });
      }
    }

    return this._dateTimeService.formatDate(date || void 0, format);
  }
}
